module.exports = __webpack_public_path__ + "img/solid_box_title@2x.3b7dd4d9.png";